module.exports = __webpack_public_path__ + "img/oa-01.3c9ee26e.svg";